import React, { useState, useEffect } from 'react';

const Countdowns = () => {
    const [time, setTime] = useState(new Date());

    // Target dates
    const targetDate1 = new Date('2025-10-24T00:00:00');
    const targetDate2 = new Date('2025-12-18T00:00:00');

    useEffect(() => {
        const timer = setInterval(() => {
            setTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const calculateTimeRemaining = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;

        if (difference > 0) {
            const months = Math.floor(difference / (1000 * 60 * 60 * 24 * 30));
            const days = Math.floor((difference % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24));
            const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);

            return { months, days, hours, minutes, seconds };
        }

        return { months: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
    };

    const CircularProgress = ({ value, max, label, size = 120, strokeWidth = 8 }) => {
        const radius = (size - strokeWidth) / 2;
        const circumference = radius * 2 * Math.PI;
        const progress = ((max - value) / max) * circumference;

        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '1em' }}>
                <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        stroke="rgba(255, 255, 255, 0.3)"
                        strokeWidth={strokeWidth}
                        fill="transparent"
                    />
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        stroke="rgba(225, 238, 221, 1)"
                        strokeWidth={strokeWidth}
                        fill="transparent"
                        strokeLinecap="round"
                        strokeDasharray={circumference}
                        strokeDashoffset={progress}
                        style={{ transition: 'stroke-dashoffset 0.5s ease' }}
                    />
                    <text
                        x={size / 2}
                        y={size / 2}
                        textAnchor="middle"
                        dy="0.3em"
                        fontSize="24"
                        fill="rgb(238, 234, 221)"
                        fontWeight="bold"
                        style={{ transform: 'rotate(90deg)', transformOrigin: `${size / 2}px ${size / 2}px` }}
                    >
                        {value}
                    </text>
                </svg>
                <p style={{ color: 'rgb(238, 234, 221)', margin: '0.5em 0', fontWeight: 'bold' }}>{label}</p>
            </div>
        );
    };

    const CountdownTimer = ({ targetDate, title }) => {
        const timeRemaining = calculateTimeRemaining(targetDate);

        return (
            <div style={{ 
                margin: '2em', 
                padding: '2em', 
                backgroundColor: 'rgba(0, 0, 0, 0.3)', 
                borderRadius: '1em',
                textAlign: 'center'
            }}>
                <h2 style={{ color: 'rgb(238, 234, 221)' }}>{title}</h2>
                <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <CircularProgress value={timeRemaining.months} max={12} label="Months" />
                    <CircularProgress value={timeRemaining.days} max={31} label="Days" />
                    <CircularProgress value={timeRemaining.hours} max={24} label="Hours" />
                    <CircularProgress value={timeRemaining.minutes} max={60} label="Minutes" />
                    <CircularProgress value={timeRemaining.seconds} max={60} label="Seconds" />
                </div>
            </div>
        );
    };

    return (
        <div style={{
            backgroundColor: 'rgb(122,147, 88)', 
            height: '100vh', 
            width: '100vw', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            alignContent: 'center', 
            flexDirection: 'column', 
            backgroundRepeat: 'no-repeat', 
            backgroundPosition: 'center', 
            backgroundSize: 'cover',
            overflowY: 'scroll'
        }}>
            <h1 style={{ color: 'rgb(238, 234, 221)', marginBottom: '2em' }}>Countdown Timers</h1>
            <CountdownTimer targetDate={targetDate1} title="October 24th, 2025" />
            <CountdownTimer targetDate={targetDate2} title="December 18th, 2025" />
        </div>
    )
};

export default Countdowns;